/* Yake Karışık Koleksiyon — storefront render katmanı (NATIVE GÖRÜNÜM, ORTAK/UNIVERSAL sürüm).
   Backend (App Proxy) periyodik karışık + filtreli veri verir; biz temanın KENDİ class'ları ve
   custom element'leriyle (product-card, price-range, accordion, option-value swatch) markup üretiriz
   → theme.css/theme.js devralır. Hata/erişilemezlik halinde native SSR fallback'e DOKUNMAYIZ.

   MAĞAZA-BAZLI ÖZELLİK BAYRAKLARI: hangi özelliğin çizileceği backend cevabındaki `features`
   nesnesinden gelir (config/stores.json → mağaza kaydı → features). Bu sayede TEK dosya tüm
   mağazalarda kullanılır; özellik açmak/kapatmak sunucuda 1 satır + restart, tema değişmez.
   Bayraklar: shuffle(backend'de), facets, sortMenu, swatches, quickBuy, themeWishlist,
   themeCompare, backendFavorites, ratingStars. Kapalı bayrak = markup da network isteği de yok. */
(function () {
  'use strict';

  // ----------------------------------------------------------------------- config
  function readConfig() {
    try {
      const n = document.querySelector('[data-yake-config]');
      return n ? JSON.parse(n.textContent) : {};
    } catch (_) {
      return {};
    }
  }
  const CFG = readConfig();
  const STR = CFG.strings || {};

  // Mağaza-bazlı özellik bayrakları — ilk backend cevabıyla dolar (data.features).
  // Dolana kadar güvenli varsayılanlar geçerli (sade mod: liste özellikleri açık, kart eklentileri kapalı).
  var FEATURES = null;
  var FEAT_DEFAULTS = { facets: true, sortMenu: true, swatches: true, quickBuy: false, themeWishlist: false, themeCompare: false, backendFavorites: false, ratingStars: false };
  function feat(name) {
    if (FEATURES && name in FEATURES) return !!FEATURES[name];
    return !!FEAT_DEFAULTS[name];
  }
  const WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];
  const CHEVRON =
    '<svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon group-expanded:rotate" viewBox="0 0 10 10"><path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"/></svg>';

  // ----------------------------------------------------------------------- helpers
  function el(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs)
      for (const k in attrs) {
        if (attrs[k] == null) continue;
        if (k === 'class') node.className = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') node.addEventListener(k.slice(2), attrs[k]);
        else node.setAttribute(k, attrs[k]);
      }
    (children || []).forEach((c) => c != null && node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c));
    return node;
  }

  function handleize(s) {
    return (s || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // -- money (Shopify formatMoney portu) --
  function formatMoney(amountMajor) {
    const cents = Math.round((parseFloat(amountMajor) || 0) * 100);
    const fmt = (CFG.currencyCodeEnabled ? CFG.moneyWithCurrencyFormat : CFG.moneyFormat) || '{{amount}}';
    return withFormat(cents, fmt);
  }
  function withFormat(cents, format) {
    const re = /\{\{\s*(\w+)\s*\}\}/;
    function fn(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) number = 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    const m = format.match(re);
    const name = m ? m[1] : 'amount';
    let v;
    switch (name) {
      case 'amount': v = fn(cents, 2); break;
      case 'amount_no_decimals': v = fn(cents, 0); break;
      case 'amount_with_comma_separator': v = fn(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fn(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fn(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fn(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = fn(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fn(cents, 2, ' ', '.'); break;
      default: v = fn(cents, 2);
    }
    return format.replace(re, v);
  }
  function currencySymbol() {
    if (CFG.currencySymbol) return CFG.currencySymbol; // ₺ (cart.currency.symbol) — native ile birebir
    return formatMoney(0).replace(/<[^>]*>/g, '').replace(/[\d.,\s ]/g, '') || '';
  }

  // -- görseller --
  function withWidth(src, w) {
    try {
      const u = new URL(src, location.origin);
      u.searchParams.set('width', w);
      return u.href;
    } catch (_) {
      return src;
    }
  }
  function srcset(src, widths) {
    return widths.map((w) => withWidth(src, w) + ' ' + w + 'w').join(', ');
  }
  function imgEl(media, opts) {
    opts = opts || {};
    const widths = opts.widths || WIDTHS;
    const a = {
      class: opts.class || '',
      src: withWidth(media.src, media.width || 800),
      srcset: srcset(media.src, widths),
      alt: media.alt || '',
      draggable: 'false',
    };
    if (opts.sizes) a.sizes = opts.sizes;
    if (media.width) a.width = media.width;
    if (media.height) a.height = media.height;
    if (opts.loading) a.loading = opts.loading;
    if (opts.fetchpriority) a.fetchpriority = opts.fetchpriority;
    return el('img', a);
  }
  function aspectClass() {
    const ar = CFG.aspectRatio || 'natural';
    return 'aspect-' + ar.split('_')[0] + (ar.indexOf('crop') >= 0 ? ' object-cover' : '');
  }
  const CARD_SIZES = '(min-width: 1400px) 18vw, (min-width: 1000px) 22vw, (min-width: 700px) 30vw, 45vw';

  // ----------------------------------------------------------------------- KART (product-card)
  function priceDisplay(p) {
    if (p.priceVaries && CFG.priceStrategy === 'from_price') {
      return { price: p.priceMin, compareAt: p.minVariantCompareAt, onSale: p.minVariantCompareAt != null && p.priceMin < p.minVariantCompareAt, useFrom: true, saleClass: false };
    }
    if (p.priceVaries) {
      return { price: p.priceMax, compareAt: p.maxVariantCompareAt, onSale: p.maxVariantCompareAt != null && p.priceMax < p.maxVariantCompareAt, useFrom: false, saleClass: true };
    }
    return { price: p.priceMin, compareAt: p.minVariantCompareAt, onSale: p.minVariantCompareAt != null && p.priceMin < p.minVariantCompareAt, useFrom: false, saleClass: false };
  }

  function priceList(p) {
    const d = priceDisplay(p);
    const base = CFG.cardTextHeading === 'heading' ? 'h6 ' : '';
    const onSaleCls = d.onSale || d.saleClass;
    const pl = el('price-list', { class: 'price-list' });

    const sp = el('sale-price', { class: base + (onSaleCls ? 'text-on-sale' : 'text-subdued') });
    sp.appendChild(el('span', { class: 'sr-only' }, ['']));
    const priceText = formatMoney(d.price);
    const ps = document.createElement('span');
    // para formatı HTML içerebilir (kur uygulaması span'ı) → innerHTML
    ps.innerHTML = ' ' + (d.useFrom && STR.fromPrice ? STR.fromPrice.replace('__PRICE__', priceText) : priceText);
    sp.appendChild(ps);
    pl.appendChild(sp);

    if (d.compareAt != null && d.price < d.compareAt) {
      const cp = el('compare-at-price', { class: base + 'text-subdued line-through' });
      cp.appendChild(el('span', { class: 'sr-only' }, ['']));
      const cs = document.createElement('span');
      cs.innerHTML = ' ' + formatMoney(d.compareAt);
      cp.appendChild(cs);
      pl.appendChild(cp);
    }
    return pl;
  }

  function badges(p) {
    const list = [];
    if (CFG.showSoldOutBadge && !p.available) {
      list.push(el('sold-out-badge', { class: 'badge badge--sold-out' }, [STR.soldOut || 'Tükendi']));
    }
    if (CFG.showDiscount) {
      const onSale = p.minVariantCompareAt != null && p.priceMin < p.minVariantCompareAt;
      if (onSale) {
        let text;
        if (p.compareAtVaries) {
          text = STR.onSale || 'İndirimde';
        } else {
          let savings;
          if (CFG.discountMode === 'percentage') {
            savings = Math.round(((p.minVariantCompareAt - p.priceMin) / p.minVariantCompareAt) * 100) + '%';
          } else {
            savings = formatMoney(p.minVariantCompareAt - p.priceMin);
          }
          text = (STR.discountBadge || '__SAVINGS__').replace('__SAVINGS__', savings);
        }
        const b = el('on-sale-badge', { class: 'badge badge--on-sale' });
        b.innerHTML = text;
        list.push(b);
      }
    }
    if (!list.length) return null;
    return el('badge-list', { class: 'badge-list badge-list--vertical' }, list);
  }

  function variantImages(p) {
    if (!feat('swatches')) return null;
    if (CFG.colorDisplay === 'hide') return null;
    const sw = (p.swatches || []).filter((s) => s.image);
    if (sw.length > 1) {
      const fs = el('fieldset', { class: 'product-card__variant-images h-stack wrap justify-center gap-1' });
      fs.appendChild(el('legend', { class: 'sr-only' }, [(p.colorOption && p.colorOption.name) || '']));
      const pid = (p.id || '').split('/').pop();
      sw.forEach((s, i) => {
        const id = 'yake-sw-' + pid + '-' + i;
        const input = el('input', { class: 'sr-only', type: 'radio', name: 'yake-swatch-' + pid, id: id, value: s.value });
        if (s.variantId) {
          input.setAttribute('data-variant-id', s.variantId);
          input.setAttribute(
            'data-variant-media',
            JSON.stringify({ alt: s.image.alt || '', preview_image: { src: s.image.src, width: s.image.width, height: s.image.height } })
          );
        }
        if (s.url) input.setAttribute('data-product-url', s.url);
        const label = el('label', { class: 'thumbnail-swatch', for: id }, [
          el('span', { class: 'sr-only' }, [s.value]),
          imgEl(s.image, { class: 'object-contain', sizes: '(max-width: 699px) 56px, 80px', widths: [56, 80, 112, 160, 200], loading: 'lazy' }),
        ]);
        fs.appendChild(input);
        fs.appendChild(label);
      });
      return fs;
    }
    if (p.featuredImage) {
      return el('div', { class: 'product-card__variant-images h-stack wrap justify-center gap-1' }, [
        el('span', { class: 'thumbnail-swatch thumbnail-swatch--static', 'aria-hidden': 'true' }, [
          imgEl(p.featuredImage, { class: 'object-cover', sizes: '(max-width: 699px) 56px, 80px', widths: [56, 80, 112, 160, 200], loading: 'lazy' }),
        ]),
      ]);
    }
    return null;
  }

  // --- Tema favori/karşılaştırma butonları (YAKESTORE) ---
  // yakestore'da favoriler+karşılaştırma TEMANIN localStorage sistemidir (yake-wishlist.js /
  // yake-compare.js). O scriptler document-level tıklama delegasyonu + MutationObserver kullanır;
  // biz sadece native snippet'lerle BİREBİR aynı data-özniteliklerini basarız, gerisini tema yapar.
  function numId(gid) { var m = String(gid || '').match(/(\d+)\s*$/); return m ? m[1] : ''; }
  function moneyText(v) { try { return formatMoney(v).replace(/<[^>]*>/g, ''); } catch (e) { return ''; } }

  var HEART_SVG = '<svg aria-hidden="true" focusable="false" fill="none" stroke-width="1.5" width="18" viewBox="0 0 24 24" class="yake-wishlist-button__icon"><path clip-rule="evenodd" d="m12 21.844-9.588-10a5.672 5.672 0 0 1-1.063-6.551v0a5.673 5.673 0 0 1 9.085-1.474L12 5.384l1.566-1.565a5.673 5.673 0 0 1 9.085 1.474v0a5.673 5.673 0 0 1-1.062 6.548L12 21.844Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var COMPARE_SVG = '<svg aria-hidden="true" focusable="false" fill="none" stroke-width="1.5" width="18" viewBox="0 0 24 24" class="yake-compare-button__icon"><path d="M9 3v18M15 3v18M3 8l3-4 3 4M21 16l-3 4-3-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function cardActions(p) {
    var wantWl = feat('themeWishlist');
    var wantCmp = feat('themeCompare');
    if (!wantWl && !wantCmp) return null;
    var img300 = p.featuredImage ? withWidth(p.featuredImage.src, 300) : '';
    var price = moneyText(p.priceMin);

    var wl = el('button', {
      type: 'button',
      class: 'yake-wishlist-button yake-wishlist-button--card',
      'data-yake-wishlist': '',
      'data-yake-handle': p.handle || '',
      'data-yake-title': p.title || '',
      'data-yake-url': p.url || '',
      'data-yake-image': img300,
      'data-yake-price': price,
      'aria-label': 'Favorilere ekle',
      'aria-pressed': 'false',
    });
    if (p.minVariantCompareAt != null && p.priceMin < p.minVariantCompareAt) {
      wl.setAttribute('data-yake-compare-price', moneyText(p.minVariantCompareAt));
    }
    wl.innerHTML = HEART_SVG;

    var optionsJson = JSON.stringify((p.options || []).map(function (o) {
      return { name: o.name, values: (o.values || []).join(', ') };
    }));
    var cmp = el('button', {
      type: 'button',
      class: 'yake-compare-button',
      'data-yake-compare': '',
      'data-yake-handle': p.handle || '',
      'data-yake-title': p.title || '',
      'data-yake-url': p.url || '',
      'data-yake-image': img300,
      'data-yake-price': price,
      'data-yake-vendor': p.vendor || '',
      'data-yake-type': p.productType || '',
      'data-yake-available': p.available ? 'true' : 'false',
      'data-yake-options': optionsJson,
      'aria-label': 'Karşılaştırmaya ekle',
      'aria-pressed': 'false',
    });
    cmp.innerHTML = COMPARE_SVG;

    var kids = [];
    if (wantWl) kids.push(wl);
    if (wantCmp) kids.push(cmp);
    return el('div', { class: 'yake-card-actions' }, kids);
  }

  // --- Backend favorileri (kalp; üyelikli, Mongo) — yalnız feat('backendFavorites') iken ---
  var favSet = new Set();
  var favBase = '';
  var favLoaded = false;
  function markHearts(scope) {
    (scope || document).querySelectorAll('[data-fav-id]').forEach(function (b) {
      b.classList.toggle('is-on', favSet.has(b.getAttribute('data-fav-id')));
    });
  }
  function toggleFav(btn, p) {
    if (!CFG.loggedIn) { window.location.href = CFG.loginUrl || '/account/login'; return; }
    var pid = btn.getAttribute('data-fav-id');
    var wasOn = btn.classList.contains('is-on');
    // Optimistik: kalbi ANINDA değiştir (kullanıcı isteğin dönmesini beklemesin)
    btn.classList.toggle('is-on', !wasOn);
    if (!wasOn) favSet.add(pid); else favSet.delete(pid);
    var body = new URLSearchParams({
      product_id: pid, handle: p.handle || '', title: p.title || '',
      image: (p.featuredImage && p.featuredImage.src) || '', price: moneyText(p.priceMin),
    });
    fetch(favBase + '/favorites/toggle', {
      method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' }, body: body.toString(),
    })
      .then(function (r) { if (r.status === 401) { window.location.href = CFG.loginUrl || '/account/login'; throw 0; } return r.json(); })
      .then(function (res) {
        var on = !!res.favorited;
        btn.classList.toggle('is-on', on);
        if (on) favSet.add(pid); else favSet.delete(pid);
      })
      .catch(function () {
        btn.classList.toggle('is-on', wasOn);
        if (wasOn) favSet.add(pid); else favSet.delete(pid);
      });
  }
  function backendFavButton(p) {
    if (!feat('backendFavorites')) return null;
    var pid = numId(p.id);
    var fav = el('button', { type: 'button', class: 'yake-fav' + (favSet.has(pid) ? ' is-on' : ''), 'aria-label': 'Favorilere ekle', 'data-fav-id': pid });
    fav.innerHTML = '♥';
    fav.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggleFav(fav, p); });
    return fav;
  }

  // Kartta ortalama yıldız (yorum verisinden) — yalnız feat('ratingStars') + yorumu olan üründe
  function cardRating(p) {
    if (!feat('ratingStars')) return null;
    if (!p.rating || !p.rating.count) return null;
    const pct = Math.max(0, Math.min(100, (p.rating.average || 0) / 5 * 100));
    const wrap = el('div', { class: 'yake-card-rating', title: p.rating.average + ' / 5' });
    wrap.innerHTML =
      '<span class="ycr-stars"><span class="ycr-bg">★★★★★</span>' +
      '<span class="ycr-fg" style="width:' + pct + '%">★★★★★</span></span>' +
      '<span class="ycr-count">(' + p.rating.count + ')</span>';
    return wrap;
  }

  // --- Hızlı satın al (+) — native product-card markup'ı birebir ---
  // Tek varyant → doğrudan sepete ekleme formu (temanın product-form elementi devralır);
  // birden çok varyant → temanın quick-buy-modal'ı (seçenek penceresi).
  function plusIcon() {
    return '<svg aria-hidden="true" focusable="false" fill="none" width="12" viewBox="0 0 12 12"><path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="' + (CFG.iconStrokeWidth || 1.6) + '"/></svg>';
  }
  function quickBuy(p) {
    if (!feat('quickBuy')) return null;
    if (!CFG.showQuickBuy || !p.available) return null;
    if (p.variantCount === 1 && p.firstVariantId) {
      var pf = document.createElement('product-form');
      var form = el('form', { method: 'post', action: '/cart/add', 'accept-charset': 'UTF-8', enctype: 'multipart/form-data' });
      form.appendChild(el('input', { type: 'hidden', name: 'form_type', value: 'product' }));
      form.appendChild(el('input', { type: 'hidden', name: 'utf8', value: '✓' }));
      form.appendChild(el('input', { type: 'hidden', name: 'on_success', value: 'force_open_drawer' }));
      form.appendChild(el('input', { type: 'hidden', name: 'quantity', value: '1' }));
      form.appendChild(el('input', { type: 'hidden', name: 'id', value: p.firstVariantId }));
      var btn = el('button', { type: 'submit', class: 'product-card__quick-add-button' });
      btn.innerHTML = '<span class="sr-only">' + (STR.addToCart || 'Sepete ekle') + '</span>' + plusIcon();
      form.appendChild(btn);
      pf.appendChild(form);
      return pf;
    }
    // varyant bilgisi yoksa (eski snapshot) da güvenli yol: modal
    var qbId = 'yake-quick-buy-' + numId(p.id);
    var frag = document.createDocumentFragment();
    var open = el('button', { type: 'button', 'aria-controls': qbId, class: 'product-card__quick-add-button' });
    open.innerHTML = '<span class="sr-only">' + (STR.chooseOptions || 'Seçenekleri seç') + '</span>' + plusIcon();
    frag.appendChild(open);
    var modal = document.createElement('quick-buy-modal');
    modal.setAttribute('handle', p.handle + (p.firstVariantId ? '?variant=' + p.firstVariantId : ''));
    modal.setAttribute('class', 'quick-buy-modal modal');
    modal.setAttribute('id', qbId);
    frag.appendChild(modal);
    return frag;
  }

  function renderCard(p, position) {
    const card = el('product-card', { class: 'product-card', handle: p.handle });

    if (p.featuredImage) {
      const fig = el('div', { class: 'product-card__figure' });
      const b = badges(p);
      if (b) fig.appendChild(b);
      const a = el('a', { href: p.url, class: 'product-card__media', draggable: 'false', 'data-instant': '' });
      a.appendChild(imgEl(p.featuredImage, { class: 'product-card__image product-card__image--primary ' + aspectClass(), sizes: CARD_SIZES, loading: position > 3 ? 'lazy' : null }));
      if (CFG.showSecondaryImage && p.secondaryImage) {
        a.appendChild(imgEl(p.secondaryImage, { class: 'product-card__image product-card__image--secondary', sizes: CARD_SIZES, loading: 'lazy', fetchpriority: 'low' }));
      }
      fig.appendChild(a);
      // native sıra: medya → (bayraklara göre) kalp / tema butonları / hızlı satın al (+)
      const bf = backendFavButton(p);
      if (bf) fig.appendChild(bf);
      const acts = cardActions(p);
      if (acts) fig.appendChild(acts);
      const qb = quickBuy(p);
      if (qb) fig.appendChild(qb);
      card.appendChild(fig);
    }

    const info = el('div', { class: 'product-card__info empty:hidden' });
    const stack = el('div', { class: 'v-stack justify-items-center gap-2' });
    if (CFG.showVendor && p.vendor) {
      stack.appendChild(
        el('a', { href: p.vendorUrl || '/collections/' + handleize(p.vendor), class: 'vendor smallcaps' + (CFG.cardTextHeading === 'heading' ? ' heading' : '') }, [p.vendor])
      );
    }
    const inner = el('div', { class: 'v-stack justify-items-center gap-1' });
    const titleCls = ('product-title ' + (CFG.cardTextHeading === 'heading' ? 'h6 ' : '') + (CFG.titleMaxLines > 0 ? 'line-clamp' : '')).trim();
    const titleA = el('a', { href: p.url, class: titleCls, 'data-instant': '' }, [p.title]);
    if (CFG.titleMaxLines > 0) titleA.style.setProperty('--line-clamp-count', CFG.titleMaxLines);
    inner.appendChild(titleA);
    inner.appendChild(priceList(p));
    const cr = cardRating(p);
    if (cr) inner.appendChild(cr);
    stack.appendChild(inner);
    info.appendChild(stack);
    const vi = variantImages(p);
    if (vi) info.appendChild(vi);
    card.appendChild(info);
    return card;
  }

  // ----------------------------------------------------------------------- FİLTRELER
  function accordion(title, contentNode, open) {
    const det = el('details', { class: 'accordion__disclosure group' });
    if (open) {
      det.setAttribute('open', '');
      det.setAttribute('aria-expanded', 'true');
    } else det.setAttribute('aria-expanded', 'false');
    // native ok rotasyonu .group[aria-expanded="true"]'a bağlı → details aç/kapatınca senkronla
    det.addEventListener('toggle', () => det.setAttribute('aria-expanded', det.open ? 'true' : 'false'));
    const toggle = el('span', { class: 'accordion__toggle h6' }, [el('span', null, [title])]);
    toggle.insertAdjacentHTML('beforeend', CHEVRON);
    det.appendChild(el('summary', null, [toggle]));
    const content = el('div', { class: 'accordion__content' });
    content.appendChild(contentNode);
    det.appendChild(content);
    return el('accordion-disclosure', { class: 'accordion' }, [det]);
  }

  // Türkçe/İngilizce renk adı → CSS rengi sözlüğü (ascii-folded anahtarlar)
  var TR_COLORS = {
    siyah: '#111111', beyaz: '#ffffff', kirmizi: '#e0202a', kirmiz: '#e0202a', mavi: '#1f4ed8',
    lacivert: '#0a1f5c', yesil: '#1f9d3a', sari: '#f5d020', turuncu: '#f08020', mor: '#7b2fbe',
    pembe: '#f06ea9', gri: '#8a8a8a', kahve: '#6b4423', kahverengi: '#6b4423', bordo: '#7c1f2e',
    bej: '#d8c3a5', ekru: '#d6cdb7', krem: '#f3ead3', vizon: '#9a8478', haki: '#6b6b3a',
    antrasit: '#3a3a3a', fume: '#5a5a5a', gumus: '#c0c0c0', altin: '#d4af37', tas: '#cbb994',
    indigo: '#3f3f8f', petrol: '#1f6f6f', fusya: '#d6248f', somon: '#fa8072', murdum: '#5b2a4a',
    turkuaz: '#1bb5b5', nar: '#9c1f2e', camel: '#c19a6b', kemik: '#e7dcc6', buz: '#dbe6e8',
    mint: '#9fe2bf', lila: '#c8a2c8', yavruagzi: '#f7b39b', kiremit: '#b04a2f', hardal: '#c9a227',
    vual: '#cdb7a5', sutlu: '#e9dcc9', acik: null, koyu: null, neon: null,
    navy: '#0a1f5c', black: '#111111', white: '#ffffff', red: '#e0202a', blue: '#1f4ed8',
    green: '#1f9d3a', beige: '#d8c3a5', brown: '#6b4423', burgundy: '#7c1f2e', pink: '#f06ea9',
    grey: '#8a8a8a', gray: '#8a8a8a', ecru: '#d6cdb7', khaki: '#6b6b3a', cream: '#f3ead3',
    taba: '#a67b5b', saks: '#4863a0', pudra: '#f0c8c8', zumrut: '#2e8b57', hasir: '#e3c98c',
    ham: '#d8cdb8', sampanya: '#f1ddbf', visne: '#911e42', menekse: '#7b3f9f', fistik: '#93c572',
    mercan: '#ff7f50', lavanta: '#b497bd', nude: '#e3bc9a', ten: '#e3bc9a', tarcin: '#7b3f1d',
    kestane: '#5b3a29', kavunici: '#f4a460', limon: '#f7e463', bronz: '#cd7f32', safir: '#0f52ba',
    yakut: '#9b111e', toprak: '#8a5a44', kar: '#ffffff', fil: '#9a9a9a', gulkurusu: '#c4888c',
  };
  function fold(s) {
    return (s || '').toString().replace(/İ/g, 'i').replace(/I/g, 'i').toLowerCase()
      .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c');
  }

  function swatchStyle(label) {
    const dl = (label || '').toLowerCase().trim();
    // 1) temanın color_swatch_config'inde tam eşleşme
    let cfg = null;
    (CFG.colorSwatchConfig || '').split(/\r?\n/).forEach((line) => {
      const idx = line.indexOf(':');
      if (idx < 0) return;
      if (line.slice(0, idx).toLowerCase().trim() !== dl) return;
      const val = line.slice(idx + 1).trim();
      if (val.indexOf('#') >= 0) cfg = '--swatch-background: linear-gradient(to right, ' + val + ', ' + val + ')';
      else if (val.indexOf('linear-gradient(') >= 0) cfg = '--swatch-background: ' + val;
    });
    if (cfg) return cfg;

    // 2) değer içindeki tanınan renk kelimelerini bul (TR sözlük)
    const matched = [];
    fold(label).split(/[^a-z]+/).filter(Boolean).forEach((w) => {
      if (TR_COLORS[w]) matched.push(TR_COLORS[w]);
    });
    if (matched.length >= 2) return '--swatch-background: linear-gradient(to right, ' + matched[0] + ' 50%, ' + matched[1] + ' 50%)';
    if (matched.length === 1) return '--swatch-background: linear-gradient(to right, ' + matched[0] + ', ' + matched[0] + ')';

    // 3) yedek: nötr açık gri (kırık görünmesin)
    return '--swatch-background: linear-gradient(to right, #e5e5e5, #e5e5e5)';
  }

  function listFacet(values, selected, onToggle) {
    const stack = el('div', { class: 'v-stack gap-2.5' });
    values.forEach((v) => {
      const id = 'yf-' + Math.random().toString(36).slice(2, 9);
      const input = el('input', { class: 'dot-checkbox', type: 'checkbox', id: id, value: v.value });
      if (selected.indexOf(v.value) >= 0) input.checked = true;
      input.addEventListener('change', () => onToggle(v.value, input.checked));
      stack.appendChild(el('div', { class: 'checkbox-control' }, [input, el('label', { for: id }, [v.value + ' (' + v.count + ')'])]));
    });
    return stack;
  }

  // İngilizce→Türkçe renk eşadları (gruplamayı birleştirir: yellow=sari)
  var COLOR_ALIASES = {
    yellow: 'sari', red: 'kirmizi', blue: 'mavi', green: 'yesil', black: 'siyah', white: 'beyaz',
    navy: 'lacivert', brown: 'kahve', burgundy: 'bordo', beige: 'bej', pink: 'pembe', grey: 'gri',
    gray: 'gri', ecru: 'ekru', cream: 'krem', khaki: 'haki', orange: 'turuncu', purple: 'mor',
    gold: 'altin', mink: 'vizon', rose: 'pembe', silver: 'gumus', oranj: 'turuncu',
    antracite: 'antrasit', anthracite: 'antrasit', saxe: 'saks', sax: 'saks', emerald: 'zumrut',
    coral: 'mercan', lavender: 'lavanta', mustard: 'hardal', salmon: 'somon',
    kahverengi: 'kahve', ten: 'nude', antrasitt: 'antrasit',
  };
  // Tek renk olan çok-kelimeli isimler (önce bunlara bakılır → ikiye bölünmez)
  var COMPOUND_COLORS = {
    'sutlu kahve': { k: 'sutlu-kahve', hex: '#b89b72', l: 'Sütlü Kahve' },
    'petrol mavi': { k: 'petrol', hex: '#1f6f6f', l: 'Petrol' },
    'petrol mavisi': { k: 'petrol', hex: '#1f6f6f', l: 'Petrol' },
    'buz mavi': { k: 'buz', hex: '#cfe3ea', l: 'Buz Mavisi' },
    'buz mavisi': { k: 'buz', hex: '#cfe3ea', l: 'Buz Mavisi' },
    'bebe mavi': { k: 'bebe-mavi', hex: '#a9c7e8', l: 'Bebe Mavi' },
    'bebe mavisi': { k: 'bebe-mavi', hex: '#a9c7e8', l: 'Bebe Mavi' },
    'gece mavisi': { k: 'gece-mavisi', hex: '#0a1f44', l: 'Gece Mavisi' },
    'yavru agzi': { k: 'yavruagzi', hex: '#f7b39b', l: 'Yavru Ağzı' },
    'gul kurusu': { k: 'gulkurusu', hex: '#c4888c', l: 'Gül Kurusu' },
    'zumrut yesili': { k: 'zumrut', hex: '#2e8b57', l: 'Zümrüt' },
    'seker pembe': { k: 'pembe', hex: '#f06ea9', l: 'Pembe' },
  };
  // Tek renk olmayan desen değerleri → tek "Desenli / Çok Renkli" karesinde toplanır
  var PATTERN_RE = /leopar|cok renkli|karisik|desen|etnik|cicek|puan|cizgi|ekose|kareli|batik|tie|dye|zebra|yilan|kaplan|simli|payet/;
  var COLOR_LABELS_TR = {
    sari: 'Sarı', kirmizi: 'Kırmızı', mavi: 'Mavi', lacivert: 'Lacivert', yesil: 'Yeşil', siyah: 'Siyah',
    beyaz: 'Beyaz', turuncu: 'Turuncu', mor: 'Mor', pembe: 'Pembe', gri: 'Gri', kahve: 'Kahve',
    bordo: 'Bordo', bej: 'Bej', ekru: 'Ekru', krem: 'Krem', vizon: 'Vizon', haki: 'Haki',
    antrasit: 'Antrasit', fume: 'Füme', gumus: 'Gümüş', altin: 'Altın', tas: 'Taş', indigo: 'İndigo',
    petrol: 'Petrol', fusya: 'Fuşya', somon: 'Somon', murdum: 'Mürdüm', turkuaz: 'Turkuaz',
    camel: 'Camel', kemik: 'Kemik', mint: 'Mint', lila: 'Lila', nar: 'Nar',
    taba: 'Taba', saks: 'Saks', pudra: 'Pudra', zumrut: 'Zümrüt', hasir: 'Hasır', ham: 'Ham',
    sampanya: 'Şampanya', visne: 'Vişne', menekse: 'Menekşe', fistik: 'Fıstık', mercan: 'Mercan',
    lavanta: 'Lavanta', nude: 'Nude', ten: 'Ten', tarcin: 'Tarçın', kestane: 'Kestane',
    kavunici: 'Kavuniçi', limon: 'Limon', bronz: 'Bronz', safir: 'Safir', yakut: 'Yakut',
    toprak: 'Toprak', kar: 'Kar', fil: 'Fil', gulkurusu: 'Gül Kurusu', altin: 'Altın',
    vizon: 'Vizon', gumus: 'Gümüş',
  };

  // Bir renk değerini tek kanonik renge indirger {k:gruplama anahtarı, hex, l:etiket}
  function canonicalColor(raw) {
    const f = fold(raw).replace(/\s+/g, ' ').trim();
    if (!f || f === '[object object]') return null; // bozuk veri (TOPSHOW feed) → atla
    for (const phrase in COMPOUND_COLORS) {
      if (f.indexOf(phrase) >= 0) return COMPOUND_COLORS[phrase];
    }
    if (/leopar/.test(f)) return { k: '_leopar', bg: 'radial-gradient(#5b3a1a 30%, transparent 32%) 0 0 / 7px 7px, #c79a5b', l: 'Leopar' };
    if (PATTERN_RE.test(f)) return { k: '_desenli', bg: 'linear-gradient(135deg,#e0202a,#f5d020 35%,#1f9d3a 60%,#1f4ed8)', l: 'Desenli / Çok Renkli' };
    const words = f.split(/[^a-z]+/).filter(Boolean);
    for (const w of words) {
      const norm = COLOR_ALIASES[w] || w;
      if (TR_COLORS[norm]) return { k: norm, hex: TR_COLORS[norm], l: COLOR_LABELS_TR[norm] || (norm.charAt(0).toUpperCase() + norm.slice(1)) };
    }
    return { k: '_diger', hex: '#d9d9d9', l: 'Diğer' };
  }

  function swatchFacet(values, selected, onToggle) {
    // kanonik renge göre grupla → tek renk kare + varyantları tek seçimde birleştir
    const groups = new Map();
    values.forEach((v) => {
      const c = canonicalColor(v.value);
      if (!c) return; // bozuk veri ([object Object]) atlanır
      if (!groups.has(c.k)) groups.set(c.k, {
        k: c.k,
        bg: c.bg || ('linear-gradient(to right, ' + c.hex + ', ' + c.hex + ')'),
        label: c.l, count: 0, raws: [], special: c.k.charAt(0) === '_' ? 1 : 0,
      });
      const g = groups.get(c.k);
      g.count += v.count;
      g.raws.push(v.value);
    });
    // gerçek renkler önce (sayıya göre); "Desenli"/"Diğer" en sona
    const arr = [...groups.values()].sort((a, b) => (a.special - b.special) || (b.count - a.count));

    const wrap = el('div', { style: 'display:grid;grid-template-columns:repeat(auto-fill,2.2rem);gap:.5rem;align-items:start' });
    arr.forEach((g) => {
      const id = 'yf-' + Math.random().toString(36).slice(2, 9);
      const input = el('input', { class: 'sr-only', type: 'checkbox', id: id, value: g.label });
      if (g.raws.some((r) => selected.indexOf(r) >= 0)) input.checked = true;
      // bu gruba ait TÜM ham değerleri seç/kaldır (kırmızı → kırmızı-beyaz da gelir)
      input.addEventListener('change', () => onToggle(g.raws, input.checked));
      const light = g.k === 'beyaz' || g.k === 'kar' || g.k === '_diger';
      const label = el('label', {
        class: 'color-swatch' + (CFG.roundColorSwatches ? ' rounded-full' : '') + (light ? ' border' : ''),
        for: id,
        'aria-label': g.label + ' (' + g.count + ')',
        'data-tooltip': g.label,
        style: '--swatch-background: ' + g.bg,
      });
      wrap.appendChild(input);
      wrap.appendChild(label);
    });
    return wrap;
  }

  function priceFacet(price, state, apply) {
    const min = price.min || 0;
    const max = price.max || 0;
    const lower = state.price_min !== '' ? parseFloat(state.price_min) : min;
    const upper = state.price_max !== '' ? parseFloat(state.price_max) : max;
    const span = max - min || 1;

    const group = el('div', { class: 'range-group' });
    group.style.setProperty('--range-min', ((lower - min) / span) * 100 + '%');
    group.style.setProperty('--range-max', ((upper - min) / span) * 100 + '%');
    const r1 = el('input', { type: 'range', class: 'range', min: String(min), max: String(max), value: String(lower) });
    const r2 = el('input', { type: 'range', class: 'range', min: String(min), max: String(max), value: String(upper) });
    group.appendChild(r1);
    group.appendChild(r2);

    const sym = currencySymbol();
    const minInput = el('input', { class: 'field', type: 'number', name: 'filter.v.price.gte', min: String(min), max: String(max), value: state.price_min, placeholder: String(Math.floor(min)) });
    const maxInput = el('input', { class: 'field', type: 'number', name: 'filter.v.price.lte', min: String(min), max: String(max), value: state.price_max, placeholder: String(Math.ceil(max)) });

    const ig = el('div', { class: 'input-group' }, [
      el('label', { class: 'input-prefix text-sm' }, [el('span', { class: 'prefix text-subdued' }, [sym]), minInput]),
      el('span', { class: 'text-subdued text-sm' }, [CFG.priceRangeTo || '–']),
      el('label', { class: 'input-prefix text-sm' }, [el('span', { class: 'prefix text-subdued' }, [sym]), maxInput]),
    ]);

    // native <price-range> custom element: slider↔input senkronu, clamp ve görsel dolgu BİREBİR
    // (input name="filter.v.price.gte/lte" şart; yoksa connectedCallback çöküyordu)
    const pr = el('price-range', { class: 'price-range' }, [group, ig]);
    pr.addEventListener('change', () => {
      state.price_min = minInput.value;
      state.price_max = maxInput.value;
      apply(true);
    });
    return pr;
  }

  function availabilityFacet(state, apply) {
    const id = 'yf-avail';
    const input = el('input', { class: 'switch', type: 'checkbox', role: 'switch', id: id, value: '1' });
    if (state.available === '1') input.checked = true;
    input.addEventListener('change', () => {
      state.available = input.checked ? '1' : '';
      apply(true);
    });
    return el('div', { class: 'checkbox-control' }, [input, el('label', { for: id, class: 'text-subdued' }, [STR.inStockOnly || 'Sadece stokta'])]);
  }

  // ----------------------------------------------------------------------- init (her section)
  function initContainer(root) {
    const proxy = root.getAttribute('data-yake-proxy');
    favBase = (proxy || '').replace(/\/listing$/, ''); // backend favori uçları için taban (yalnız bayrak açıksa kullanılır)
    const collection = root.getAttribute('data-yake-collection');
    const pageSize = parseInt(root.getAttribute('data-yake-page-size') || '24', 10);
    if (!proxy || !collection) return;

    const gridEl = root.querySelector('[data-yake-grid]');
    const facetsEls = [...root.querySelectorAll('[data-yake-facets]')]; // sidebar (masaüstü) + drawer (mobil)
    const activeEl = root.querySelector('[data-yake-active-facets]');
    const pagEl = root.querySelector('[data-yake-pagination]');
    const countEl = root.querySelector('[data-yake-count]');
    const filterToggle = root.querySelector('[data-yake-filter-toggle]');
    const filtersWrap = root.querySelector('[data-yake-filters]');
    const sortWrap = root.querySelector('[data-yake-sort]');
    const sortToggle = root.querySelector('[data-yake-sort-toggle]');
    const sortPanel = root.querySelector('[data-yake-sort-panel]');

    function readState() {
      const p = new URLSearchParams(location.search);
      const options = {};
      [...p.keys()].forEach((k) => {
        if (k.indexOf('option_') === 0) options[k.slice(7)] = p.getAll(k).filter(Boolean);
      });
      return {
        page: Math.max(1, parseInt(p.get('page') || '1', 10) || 1),
        vendor: p.getAll('vendor').filter(Boolean),
        product_type: p.getAll('product_type').filter(Boolean),
        tag: p.getAll('tag').filter(Boolean),
        options: options,
        price_min: p.get('price_min') || '',
        price_max: p.get('price_max') || '',
        available: p.get('available') || '',
        sort: p.get('sort_by') || '',
      };
    }
    function writeState(state, push) {
      const p = new URLSearchParams(location.search);
      const setMulti = (k, arr) => { p.delete(k); (arr || []).filter(Boolean).forEach((v) => p.append(k, v)); };
      const setOne = (k, v) => { if (v) p.set(k, v); else p.delete(k); };
      setMulti('vendor', state.vendor);
      setMulti('product_type', state.product_type);
      setMulti('tag', state.tag);
      setOne('price_min', state.price_min);
      setOne('price_max', state.price_max);
      setOne('available', state.available);
      setOne('sort_by', state.sort);
      [...p.keys()].filter((k) => k.indexOf('option_') === 0).forEach((k) => p.delete(k));
      Object.keys(state.options).forEach((name) => setMulti('option_' + name, state.options[name]));
      if (state.page > 1) p.set('page', state.page); else p.delete('page');
      history[push ? 'pushState' : 'replaceState']({}, '', location.pathname + (p.toString() ? '?' + p.toString() : ''));
    }
    function buildQuery(state) {
      const p = new URLSearchParams();
      p.set('collection', collection);
      p.set('page', state.page);
      p.set('page_size', pageSize);
      state.vendor.forEach((v) => p.append('vendor', v));
      state.product_type.forEach((v) => p.append('product_type', v));
      state.tag.forEach((v) => p.append('tag', v));
      if (state.price_min) p.set('price_min', state.price_min);
      if (state.price_max) p.set('price_max', state.price_max);
      if (state.available) p.set('available', state.available);
      if (state.sort) p.set('sort_by', state.sort);
      Object.keys(state.options).forEach((name) => state.options[name].forEach((v) => p.append('option_' + name, v)));
      return p.toString();
    }

    function renderGrid(items) {
      gridEl.innerHTML = '';
      if (!items.length) {
        gridEl.appendChild(el('p', { class: 'text-subdued' }, [STR.noResults || 'Sonuç yok.']));
        return;
      }
      items.forEach((p, i) => gridEl.appendChild(renderCard(p, i + 1)));
    }

    function renderFacets(facets, state, apply) {
      const toggle = (arr, val, on) => {
        const i = arr.indexOf(val);
        if (on && i < 0) arr.push(val);
        if (!on && i >= 0) arr.splice(i, 1);
      };
      // sidebar + drawer konteynerlerinin hepsine bas (aynı state'i paylaşırlar)
      facetsEls.forEach((container) => {
        // önceki açık/kapalı durumları hatırla; İLK render'da hepsi AÇIK gelir (native open_filters_by_default)
        const known = {};
        container.querySelectorAll('details').forEach((d) => {
          const t = d.querySelector('.accordion__toggle > span');
          if (t) known[t.textContent] = d.open;
        });
        const isOpen = (title) => (title in known ? known[title] : false); // varsayılan KAPALI; kullanıcı açtıysa korunur
        container.innerHTML = '';
        const add = (title, node) => node && container.appendChild(accordion(title, node, isOpen(title)));

        if (facets.vendors && facets.vendors.length)
          add('Markalar', listFacet(facets.vendors, state.vendor, (v, on) => { toggle(state.vendor, v, on); apply(true); }));
        (facets.options || []).forEach((opt) => {
          if (fold(opt.name) === 'title') return; // 'Title' (tek-varyant varsayılanı) hiç gösterilmez; diğer gizlemeler backend'de (mağaza-bazlı hideFacets)
          if (!state.options[opt.name]) state.options[opt.name] = [];
          const sel = state.options[opt.name];
          const cb = (v, on) => { toggle(sel, v, on); apply(true); };
          add(opt.name, opt.presentation === 'swatch'
            ? swatchFacet(opt.values, sel, (raws, on) => { raws.forEach((r) => toggle(sel, r, on)); apply(true); })
            : listFacet(opt.values, sel, cb));
        });
        if (facets.price && facets.price.max > 0) add('Fiyat', priceFacet(facets.price, state, apply));
        add('Stok durumu', availabilityFacet(state, apply));
      });
    }

    function renderActive(state, apply) {
      if (!activeEl) return;
      activeEl.innerHTML = '';
      const chips = [];
      const addChip = (label, remove) => {
        const close = el('a', { class: 'tap-area link-faded', href: '#', onclick: (e) => { e.preventDefault(); remove(); apply(true); } });
        close.innerHTML = '<svg aria-hidden="true" focusable="false" fill="none" width="10" viewBox="0 0 10 10"><path d="m1 1 8 8M9 1 1 9" stroke="currentColor"/></svg>';
        chips.push(el('div', { class: 'removable-facet' }, [close, el('span', { class: 'text-subdued' }, [label])]));
      };
      state.vendor.forEach((v) => addChip(v, () => state.vendor.splice(state.vendor.indexOf(v), 1)));
      state.product_type.forEach((v) => addChip(v, () => state.product_type.splice(state.product_type.indexOf(v), 1)));
      state.tag.forEach((v) => addChip(v, () => state.tag.splice(state.tag.indexOf(v), 1)));
      Object.keys(state.options).forEach((name) => {
        const sel = state.options[name];
        if (['renk', 'color', 'colour'].includes(fold(name))) {
          // renk: kanonik gruba göre tek chip (grup etiketi "Mavi"); kaldırınca grubun TÜM ham değerleri gider
          const seen = {};
          sel.forEach((v) => {
            const c = canonicalColor(v);
            if (!c || seen[c.k]) return;
            seen[c.k] = true;
            addChip(c.l, () => { state.options[name] = state.options[name].filter((r) => { const cc = canonicalColor(r); return !cc || cc.k !== c.k; }); });
          });
        } else {
          sel.forEach((v) => addChip(v, () => state.options[name].splice(state.options[name].indexOf(v), 1)));
        }
      });
      if (state.available === '1') addChip(STR.inStockOnly || 'Stokta', () => { state.available = ''; });
      if (state.price_min || state.price_max) addChip('₺' + (state.price_min || '0') + ' - ' + (state.price_max || '∞'), () => { state.price_min = ''; state.price_max = ''; });
      if (!chips.length) return;
      const box = el('div', { class: 'active-facets' }, chips);
      if (chips.length > 1) {
        const clear = el('a', { class: 'facets-clear-all text-subdued', href: '#', onclick: (e) => { e.preventDefault(); clearAll(); } }, [el('span', { class: 'link' }, [STR.clearFilters || 'Temizle'])]);
        box.appendChild(clear);
      }
      activeEl.appendChild(box);
    }

    function renderPagination(page, pages, go) {
      pagEl.innerHTML = '';
      if (pages <= 1) { pagEl.hidden = true; return; }
      pagEl.hidden = false;
      const link = (label, target, opts) => {
        opts = opts || {};
        if (opts.disabled || opts.current) {
          const s = el('span', { class: 'pagination__link pagination__link--disabled h6' }, []);
          if (opts.current) s.setAttribute('aria-current', 'page');
          s.innerHTML = label;
          return s;
        }
        const a = el('a', { class: 'pagination__link h6', href: '#' });
        a.innerHTML = label;
        // facet-link sarmalı KULLANMA: temanın facet-link'i tıklamayı Section Rendering'e
        // yönlendirip section'ı SSR'la değiştiriyor → filtre/pagination kayboluyor. Kendi handler'ımız:
        a.addEventListener('click', (e) => { e.preventDefault(); go(target); });
        return a;
      };
      const chevL = '<svg aria-hidden="true" focusable="false" fill="none" width="11" viewBox="0 0 10 10" style="transform:rotate(90deg)"><path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"/></svg>';
      const chevR = '<svg aria-hidden="true" focusable="false" fill="none" width="11" viewBox="0 0 10 10" style="transform:rotate(-90deg)"><path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"/></svg>';
      if (page > 1) pagEl.appendChild(link(chevL, page - 1));
      const nums = new Set([1, pages, page]);
      for (let i = page - 2; i <= page + 2; i++) if (i >= 1 && i <= pages) nums.add(i);
      const sorted = [...nums].sort((a, b) => a - b);
      let prev = 0;
      sorted.forEach((n) => {
        if (n - prev > 1) pagEl.appendChild(link('…', null, { disabled: true }));
        pagEl.appendChild(link(String(n), n, { current: n === page }));
        prev = n;
      });
      if (page < pages) pagEl.appendChild(link(chevR, page + 1));
    }

    let firstOk = false;
    function clearAll() {
      const fresh = { page: 1, vendor: [], product_type: [], tag: [], options: {}, price_min: '', price_max: '', available: '' };
      writeState(fresh, false);
      load(fresh, false);
    }

    async function load(state, push) {
      root.classList.add('is-loading');
      try {
        const res = await fetch(proxy + '?' + buildQuery(state), { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('proxy ' + res.status);
        const data = await res.json();
        firstOk = true;
        if (data.features) FEATURES = data.features; // mağaza bayrakları (stores.json'dan)
        applyFeatureVisibility();
        renderGrid(data.items);
        if (feat('facets')) renderFacets(data.facets, state, (reset) => { if (reset) state.page = 1; writeState(state, false); load(state, false); });
        renderActive(state, (reset) => { if (reset) state.page = 1; writeState(state, false); load(state, false); });
        renderPagination(data.page, data.pages, (t) => {
          state.page = t;
          writeState(state, true);
          load(state, true);
          window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
        });
        if (countEl && STR.productsCount) countEl.textContent = STR.productsCount.replace('__COUNT__', data.total);
        else if (countEl) countEl.textContent = data.total + ' ürün';
      } catch (err) {
        // backend yok/hata → native SSR fallback olduğu gibi kalır
        console.warn('[yake] backend listelemesi başarısız, native fallback kullanılıyor:', err.message);
      } finally {
        root.classList.remove('is-loading');
        root.classList.remove('is-booting'); // ilk açılış spinner'ını kaldır (SSR→bizim grid takası gizlendi)
      }
    }

    if (filterToggle && filtersWrap) filterToggle.addEventListener('click', () => filtersWrap.scrollIntoView({ behavior: 'smooth' }));
    // sıralama menüsü (native sort_options; seçim SPA olarak uygulanır)
    if (sortToggle && sortPanel && sortWrap) {
      const sortToolbar = sortWrap.closest('.collection-toolbar');
      const closeSort = () => { sortPanel.hidden = true; sortToggle.setAttribute('aria-expanded', 'false'); if (sortToolbar) sortToolbar.classList.remove('yake-sort-raise'); };
      const markSort = (val) => sortWrap.querySelectorAll('[data-yake-sort-option]').forEach((b) => {
        if (b.getAttribute('value') === val) b.setAttribute('aria-selected', 'true'); else b.removeAttribute('aria-selected');
      });
      sortToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const willOpen = sortPanel.hidden;
        sortPanel.hidden = !willOpen;
        sortToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (sortToolbar) sortToolbar.classList.toggle('yake-sort-raise', willOpen); // sadece açıkken yükselt (facet'leri örtmesin)
      });
      sortWrap.querySelectorAll('[data-yake-sort-option]').forEach((b) => b.addEventListener('click', () => {
        const s = readState();
        s.sort = b.getAttribute('value');
        s.page = 1;
        writeState(s, true);
        load(s, true);
        markSort(s.sort);
        closeSort();
        window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
      }));
      document.addEventListener('click', (e) => { if (!sortWrap.contains(e.target)) closeSort(); });
      markSort(readState().sort);
    }

    // Bayraklara göre araç çubuğu/yan panel görünürlüğü + backend favori ön-yüklemesi.
    // Bayraklar ilk backend cevabıyla geldiği için her load() sonrası çağrılır (idempotent).
    function applyFeatureVisibility() {
      if (sortWrap) sortWrap.hidden = !feat('sortMenu');
      const facetsOn = feat('facets');
      if (filtersWrap) filtersWrap.hidden = !facetsOn;
      const mobBtn = root.querySelector('[aria-controls="facets-drawer"]');
      if (mobBtn && mobBtn.parentElement) mobBtn.parentElement.hidden = !facetsOn;
      if (feat('backendFavorites') && CFG.loggedIn && !favLoaded) {
        favLoaded = true;
        fetch(favBase + '/favorites', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((d) => { favSet = new Set(d.ids || []); markHearts(root); })
          .catch(() => {});
      }
    }

    window.addEventListener('popstate', () => load(readState(), false));
    load(readState(), false);
  }

  function boot() {
    document.querySelectorAll('[data-yake-collection]').forEach(initContainer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
